/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { authRequestRequestSchema } from "./authRequestRequestSchema.ts";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { tokensSchema } from "./tokensSchema.ts";

export const userAuthCreateStatus200Schema = tokensSchema.describe("Сериализатор вывода токена - для документации.");

export const userAuthCreateStatus400Schema = errorResponseSchema;

export const userAuthCreateResponseSchema = z.union([userAuthCreateStatus200Schema, userAuthCreateStatus400Schema]);

export const userAuthCreateDataSchemaJson = authRequestRequestSchema.describe("Сериализатор авторизации пользователя.");

export const userAuthCreateDataSchemaXml = authRequestRequestSchema.describe("Сериализатор авторизации пользователя.");

export const userAuthCreateDataSchema = z.union([userAuthCreateDataSchemaJson, userAuthCreateDataSchemaXml]);
